module.exports = __webpack_public_path__ + "img/shafaat.115c5b03.jpg";